var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4778 3.13645C12.7456 2.40422 11.5584 2.40422 10.8262 3.13645L4.06446 9.89816C2.81966 11.143 2.81966 13.1612 4.06446 14.406C5.30925 15.6508 7.32747 15.6508 8.57226 14.406L15.334 7.64426C15.6269 7.35137 16.1017 7.35137 16.3946 7.64426C16.6875 7.93715 16.6875 8.41203 16.3946 8.70492L9.63292 15.4666C7.80234 17.2972 4.83438 17.2972 3.0038 15.4666C1.17321 13.636 1.17321 10.6681 3.0038 8.8375L9.7655 2.07579C11.0835 0.757776 13.2205 0.757775 14.5385 2.07579C15.8565 3.39381 15.8565 5.53075 14.5385 6.84876L8.04193 13.3453C7.23648 14.1508 5.93057 14.1508 5.12512 13.3453C4.31966 12.5399 4.31966 11.2339 5.12512 10.4285L10.8262 4.72744C11.1191 4.43455 11.5939 4.43455 11.8868 4.72744C12.1797 5.02034 12.1797 5.49521 11.8868 5.7881L6.18578 11.4892C5.96611 11.7088 5.96611 12.065 6.18578 12.2846C6.40545 12.5043 6.7616 12.5043 6.98127 12.2846L13.4778 5.7881C14.21 5.05587 14.21 3.86869 13.4778 3.13645Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip0);
export default __webpack_public_path__ + "static/media/paperclip0.f1de4fdb485c9918db9c6c29ff07bd19.svg";
export { ForwardRef as ReactComponent };